import { ButtonPrimary, ButtonTertiary } from "@nova/component-btn"
import { useTranslation } from "@nova/use-translation"
import Image from "next/image"
import { zIndex } from "@nova/constants"
import { useAppDispatch, useAppSelector } from "integrations/redux/hooks"
import { selectUserEmail, selectUserID } from "user/profile/selectors"
import useAppPages from "integrations/nextjs/routing/useAppPages"
import { useCallback } from "react"
import { updateWorkspaceMemberAccessRequest } from "features/entity-caching/members/UserManagementSlice"
import { setGlobalNotificationContext } from "user/profile/slice"
import { GlobalNotificationStatus } from "@nova/component-global-notification"
import { HighPriorityNovaModalContainer } from "@nova/component-nova-modal-container"
import { useParams } from "react-router"

export default function Page403() {
    const { t } = useTranslation()
    const dispatch = useAppDispatch()

    const { projectId, workspaceId, "*": splat } = useParams()

    const entityId = projectId || splat?.split("/").at(-1) || workspaceId
    const selfId = useAppSelector(selectUserID) || ""
    const email = useAppSelector(selectUserEmail)

    const { redirectToRootPage } = useAppPages()

    const handleAccessRequest = useCallback(async () => {
        if (!entityId) return
        dispatch(
            updateWorkspaceMemberAccessRequest({
                workspaceId: workspaceId || undefined,
                projectId: projectId || undefined,
                userId: selfId,
                accessRequestId: entityId, // todo: get the current tag tree too
            })
        )
        dispatch(
            setGlobalNotificationContext({
                message: "Your access request has been sent to the admin(s).",
                status: GlobalNotificationStatus.success,
                timeoutInMs: 3000,
            })
        )
        //let the notification surface before we reroute
        setTimeout(() => {
            redirectToRootPage()
        }, 3000)
    }, [entityId, dispatch, workspaceId, projectId, selfId, redirectToRootPage])

    return (
        <div className="nova-center-screen-container">
            <Image
                src="/images/logos/nova-logo-with-title.svg"
                alt="Nova"
                width={150}
                height={0}
                className="nova-logo-title absolute top-[28%]"
                style={{ zIndex: zIndex.SystemInitializing }}
                priority={true}
            />
            <HighPriorityNovaModalContainer
                title="Request Access"
                className="w-[30rem]"
                bottomBar={
                    <div className="w-full flex justify-end items-center gap-2">
                        <ButtonTertiary title="Return to Workspace" onClick={redirectToRootPage} />
                        <ButtonPrimary onClick={handleAccessRequest} title="Request Access" />
                    </div>
                }
            >
                <div className="mt-5 text-center">
                    {t("You can view this once your request is approved.")}
                </div>
                <div className="mt-4 text-xs font-light text-center">
                    {t(`Signed in as ${email}`)}
                </div>
            </HighPriorityNovaModalContainer>
        </div>
    )
}
